export default {
  indicators: [],
  filters: []
}
